import { Field, FieldLabel } from '@/components/ui/field'
import { MultipleDropzone } from '@/components/ui/multiple-dropzone'
import { Textarea } from '@/components/ui/textarea'
import type { PolicyChangeReply } from '@/models/policyChange'

// What the server's upload checks take.
const ACCEPT = '.pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.csv'

interface AskReplyFieldsProps {
  id: string
  value: PolicyChangeReply
  onChange: (reply: PolicyChangeReply) => void
  /** The broker asked for a document, so the upload isn't optional. */
  needsDocument: boolean
  replyLabel?: string
  /** The note can be left out, as when the changes themselves are the answer. */
  replyOptional?: boolean
}

/** A note and files for the broker, in reply to what they asked. */
export function AskReplyFields({
  id,
  value,
  onChange,
  needsDocument,
  replyLabel = 'Your answer',
  replyOptional,
}: AskReplyFieldsProps) {
  return (
    <div className="flex flex-col gap-4">
      <Field>
        <FieldLabel htmlFor={`${id}-reply`} optional={replyOptional}>
          {replyLabel}
        </FieldLabel>
        <Textarea
          id={`${id}-reply`}
          rows={3}
          value={value.reply}
          onChange={(event) => onChange({ ...value, reply: event.target.value })}
        />
      </Field>
      <Field>
        <FieldLabel optional={!needsDocument}>Documents</FieldLabel>
        <MultipleDropzone
          accept={ACCEPT}
          maxSizeMB={25}
          maxWidth={640}
          onChange={(files) => onChange({ ...value, files })}
        />
      </Field>
    </div>
  )
}
